import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent } from 'primeng/table';
import { DeliveryHistoryItem } from 'src/app/api/models';
import { DeliveryService } from 'src/app/api/services';
import { ListComponent } from 'src/app/utils/list.component';

@Component({
  selector: 'app-modal-delivery-history',
  templateUrl: './modal-delivery-history.component.html',
  styleUrls: ['./modal-delivery-history.component.scss'],
})
export class ModalDeliveryHistoryComponent extends ListComponent {
  deliveryID?: number;
  total_records = 0;
  delivery_histories: DeliveryHistoryItem[] = [];

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];

  constructor(
    public config: DynamicDialogConfig,
    private deliveryService: DeliveryService
  ) {
    super();
    this.deliveryID = config.data.delivery_id;
  }

  fetchDeliveryHistory(delivery_id: number, $event: TableLazyLoadEvent) {
    this.deliveryService.deliveryControllerFindDeliveryHistory({ id: delivery_id }).subscribe({
      next: res => {
        this.delivery_histories = res.data.list;
        this.total_records = res.data.count;
      },
      error: e => {
        console.log(e);
      },
    });
  }
}
